/**
 * Dashboard widget copy from DB (widget_library.name/description) is English for admin/seed data.
 * All user-visible titles and descriptions must come from locales: dashboard.widgetTitles / widgetDescriptions
 * keyed by widget_key. Use translateWidgetTitle / translateWidgetDescription (or useWidgetTitle hook).
 */

export function translateWidgetTitle(t, widget) {
  const key = widget?.widget_key;
  if (!key) return widget?.name || '';
  const path = `dashboard.widgetTitles.${key}`;
  const translated = t(path);
  return translated !== path ? translated : widget?.name || '';
}

export function translateWidgetDescription(t, widget) {
  const key = widget?.widget_key;
  if (!key) return widget?.description || '';
  const path = `dashboard.widgetDescriptions.${key}`;
  const translated = t(path);
  return translated !== path ? translated : widget?.description || '';
}

/** Maps widget_library.category (English) to a translated label when a key exists. */
export function translateWidgetCategory(t, category) {
  if (!category) return '';
  const path = `dashboard.widgetCategories.${category}`;
  const translated = t(path);
  return translated !== path ? translated : category;
}
